import type { ApiError } from './api.js';

// ── עצירה אמיתית בסריקה → מסך עצירה גדול (אלי 21/10/2026) ─────────────────
//
// „חלק שעוצר בייצור צריך התראה גדולה יותר בסריקה. אחרת זה נראה כמו התראה
// שחסר שרטוט או משהו בסגנון ואנשים ממשיכים לעבוד." עד היום כל סירוב של השער
// (work-gate) הוצג באותה שורת שגיאה. כאן — הקודים שאלי בחר, נקלטים במקום אחד
// (api.ts) כדי שכל עמדה תקבל את אותו מסך, בלי לגעת בכל מסך בנפרד.

export const STOP_CODES = new Set(['NC_BLOCKING', 'PRODUCTION_HOLD', 'ECO_OPEN', 'FAI_PENDING', 'ENG_INSPECTION_PENDING']);

/** האם הסירוב הזה הוא „עצור" — כולל „מנהל קבע לחכות לשרטוט" (WAIT). */
export function isStop(e: Pick<ApiError, 'code' | 'details'>): boolean {
  if (STOP_CODES.has(e.code)) return true;
  const d = e.details as { decision?: string } | undefined;
  return e.code === 'DRAWING_MISSING' && d?.decision === 'WAIT';
}

type Listener = (e: ApiError) => void;
const listeners = new Set<Listener>();
export const stopSignal = {
  on(fn: Listener): () => void { listeners.add(fn); return () => listeners.delete(fn); },
  emit(e: ApiError): void {
    // רק בעמדות הרצפה והשטח — במשרד אותו סירוב נשאר בשורה של המסך.
    const p = typeof window !== 'undefined' ? window.location.pathname : '';
    if (!p.startsWith('/scan') && !p.startsWith('/field')) return;
    listeners.forEach((fn) => fn(e));
  },
};
